(function () {
  // Le GIF boucle indéfiniment tout seul (plusieurs annonces animées
  // à l'intérieur du fichier) — s'affiche immédiatement, ne disparaît
  // jamais toute seule. Seule la croix (zone invisible superposée)
  // la masque.
  var card = document.getElementById('luther-social-proof');
  if (!card) return;

  var closeBtn = document.getElementById('luther-social-proof-close');

  window.requestAnimationFrame(function () {
    card.classList.add('is-visible');
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      card.classList.remove('is-visible');
    });
  }
})();
